import React, { FC } from 'react';
import classNames from 'classnames';
import * as Contentful from 'contentful';
import { Link } from '@/navigation';
import { TypeLink_internalFields } from '@/core/generated-types';
import { slugBuilder } from '@/core/contentfulConfig';
import { ChevronIcon } from '../Icons';

export interface InternalLinkProps {
  link: Contentful.Entry<TypeLink_internalFields>;
  classes?: string; // Append to the default classes
  children?: React.ReactNode;
  hideArrow?: boolean;
  chevronClasses?: string;
  isBreadcrumb?: boolean;
  testId?: string;
  queryString?: string;
  onClick?: React.MouseEventHandler<any> | undefined;
}

const InternalLink: FC<InternalLinkProps> = ({
  link,
  classes = '',
  children,
  hideArrow,
  chevronClasses,
  isBreadcrumb,
  testId = 'link-internalLink',
  queryString,
  onClick,
}) => {
  if (!link) {
    console.warn('Invalid link.', link);
    return null;
  }

  const href = slugBuilder(link, queryString);

  if (!link.fields) {
    return null;
  }

  return (
    <Link
      key={link.sys.id}
      href={href}
      className={classNames('flex flex-row items-center gap-1.5', classes, {
        'text-indigo hover:opacity-80': isBreadcrumb,
      })}
      data-testid={testId}
      onClick={onClick}
    >
      {isBreadcrumb && (
        <ChevronIcon
          color="indigo"
          direction="left"
          height={13}
          width={13}
          strokeWidth={3}
          classes="self-center"
        />
      )}
      {children ? children : link.fields.linkText}
      {link.fields.hasArrow && !hideArrow && (
        <ChevronIcon
          color="indigo"
          direction="right"
          height={13}
          width={13}
          strokeWidth={3}
          classes={classNames('relative top-[1px]', chevronClasses)}
        />
      )}
    </Link>
  );
};

export default React.memo(InternalLink);
